import "./bookings.css";
import Table from "react-bootstrap/Table";
import { useState } from "react";

import { BsTrash } from "react-icons/bs";

function Bookings() {
  const [value, setValue] = useState();

  const deleteBooking = (e, i) => {
    var storedBookings = JSON.parse(localStorage.getItem("bookings"));
    storedBookings.splice(i, 1);
    localStorage.setItem("bookings", JSON.stringify(storedBookings));
    setValue({});
    alert('Reservation cancelled!');
    if(value !== undefined){
    }
  };

  let bookingRows;
  if (localStorage.getItem("bookings")) {
    bookingRows = JSON.parse(localStorage.getItem("bookings")).map(
      (info, i) => {
        return (
          <tr key={i + 1}>
            <td className="bookingRows">
              <b>{i + 1}</b>
            </td>
            <td>{info.name}</td>
            <td>{info.date}</td>
            <td>{info.time}</td>
            <td>{info.email}</td>
            <td>
              <BsTrash onClick={(e) => deleteBooking(e, i)} />
            </td>
          </tr>
        );
      }
    );
  } else {
    bookingRows = () => {
      return <p>No bookings found</p>;
    };
  }

  return (
    <div className="bookings">
      {localStorage.getItem("bookings") &&
        localStorage.getItem("bookings") !== "[]" && (
          <h5>List of your reservations</h5>
        ) && (
          <Table
            striped
            responsive
            style={{
              maxWidth: "60vw",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Business Name</th>
                <th>Date</th>
                <th>Time</th>
                <th>E-mail</th>
              </tr>
            </thead>
            <tbody>{bookingRows}</tbody>
          </Table>
        )}
      {(!localStorage.getItem("bookings") ||
        localStorage.getItem("bookings") === "[]") && (
        <p className="text-danger" style={{'fontSize':'1.4rem','fontWeight':500,'backgroundColor':'#ffffff','maxWidth':'25rem','borderRadius':'3rem','marginLeft':'auto','marginRight':'auto'}}>No reservations to show</p>
      )}
    </div>
  );
}
export default Bookings;
